import {useEffect, useState} from 'react';

const useInfoBannerHeight = () => {
  const [bannerHeight, setBannerHeight] = useState(0);
  useEffect(() => {
    const handleBannerHeight = (e: Event) => {
      const {height} = (e as CustomEvent).detail;
      setBannerHeight(height);
    };
    document.addEventListener('banner_height', handleBannerHeight);
    return () => {
      document.removeEventListener('banner_height', handleBannerHeight);
    };
  }, []);

  return bannerHeight;
};

export default useInfoBannerHeight;
